import { QueryClient } from '@tanstack/react-query';

/**
 * In-memory only: nothing is persisted to storage or cached by the service
 * worker. Owner data is wiped with queryClient.clear() on logout.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, err) => count < 2 && (err as { code?: string }).code === 'network',
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});
